import React, { useState, useEffect } from 'react';
import { Search, Moon, MoonStar, RefreshCw, Users, Cloud, Tag, ChevronDown, ChevronRight } from 'lucide-react';
import DateFilterComponent from '../../components/shared/DateFilterComponent';
import ServiciosPorNubeTable from '../../components/finops/ServiciosPorNubeTable';
import MultiNubePieChart from '../../components/finops/MultiNubePieChart';
import ProductoPieChart from '../../components/finops/ProductoPieChart';
// import TablaClientes from '../../components/finops/TablaClientes';
import { fetchFinopsDashboardData } from '../../api';


import { 
  fetchFinopsClientes, 
  fetchClienteDetalles,
  fetchClienteOportunidades,
  fetchOportunidadServicios,
  fetchServiciosPorNube,
} from '../../api';

// Función para obtener colores de nube
const getColorNube = (nube) => {
  if (!nube) return { bg: 'bg-gray-500/20', text: 'text-gray-400', border: 'border-gray-500/30' };
  
  const nubeNormalizada = nube.toLowerCase();
  
  const coloresNube = {
    // AWS - Naranja oficial
    'aws': { bg: 'bg-orange-500/20', text: 'text-orange-400', border: 'border-orange-500/30' },
    'amazon': { bg: 'bg-orange-500/20', text: 'text-orange-400', border: 'border-orange-500/30' },
    'amazon aws': { bg: 'bg-orange-500/20', text: 'text-orange-400', border: 'border-orange-500/30' },
    
    // Microsoft Azure - Azul oficial
    'azure': { bg: 'bg-blue-500/20', text: 'text-blue-400', border: 'border-blue-500/30' },
    'microsoft azure': { bg: 'bg-blue-500/20', text: 'text-blue-400', border: 'border-blue-500/30' },
    
    // Microsoft 365 - Verde oficial
    '365': { bg: 'bg-green-500/20', text: 'text-green-400', border: 'border-green-500/30' },
    'microsoft 365': { bg: 'bg-green-500/20', text: 'text-green-400', border: 'border-green-500/30' },
    'office 365': { bg: 'bg-green-500/20', text: 'text-green-400', border: 'border-green-500/30' },
    
    // Google GCP - Azul Google
    'gcp': { bg: 'bg-blue-600/20', text: 'text-blue-300', border: 'border-blue-600/30' },
    'google gcp': { bg: 'bg-blue-600/20', text: 'text-blue-300', border: 'border-blue-600/30' },
    'google cloud': { bg: 'bg-blue-600/20', text: 'text-blue-300', border: 'border-blue-600/30' },
    
    // Google Workspace - Rojo/Multicolor Google
    'workspace': { bg: 'bg-red-500/20', text: 'text-red-400', border: 'border-red-500/30' },
    'google workspace': { bg: 'bg-red-500/20', text: 'text-red-400', border: 'border-red-500/30' },
    
    // Huawei - Rojo oficial
    'huawei': { bg: 'bg-red-600/20', text: 'text-red-400', border: 'border-red-600/30' },
    'huawei cloud': { bg: 'bg-red-600/20', text: 'text-red-400', border: 'border-red-600/30' },
    
    // Alibaba - Naranja
    'alibaba': { bg: 'bg-orange-600/20', text: 'text-orange-400', border: 'border-orange-600/30' },
    'alibaba cloud': { bg: 'bg-orange-600/20', text: 'text-orange-400', border: 'border-orange-600/30' },
    
    // Oracle - Rojo
    'oracle': { bg: 'bg-red-700/20', text: 'text-red-400', border: 'border-red-700/30' },
    'oracle cloud': { bg: 'bg-red-700/20', text: 'text-red-400', border: 'border-red-700/30' },
    
    // IBM - Azul oscuro
    'ibm': { bg: 'bg-blue-900/20', text: 'text-blue-300', border: 'border-blue-900/30' },
    'ibm cloud': { bg: 'bg-blue-900/20', text: 'text-blue-300', border: 'border-blue-900/30' },
    
    // Digital Ocean - Azul claro
    'digitalocean': { bg: 'bg-cyan-500/20', text: 'text-cyan-400', border: 'border-cyan-500/30' },
    'digital ocean': { bg: 'bg-cyan-500/20', text: 'text-cyan-400', border: 'border-cyan-500/30' },
    
    // Default - Gris
    'ninguna': { bg: 'bg-gray-500/20', text: 'text-gray-400', border: 'border-gray-500/30' },
    'other': { bg: 'bg-gray-500/20', text: 'text-gray-400', border: 'border-gray-500/30' },
  };
  
  // Buscar coincidencia exacta primero
  if (coloresNube[nubeNormalizada]) {
    return coloresNube[nubeNormalizada];
  }
  
  // Buscar coincidencia parcial
  for (const [key, value] of Object.entries(coloresNube)) {
    if (nubeNormalizada.includes(key) || key.includes(nubeNormalizada)) {
      return value;
    }
  }
  
  // Default si no se encuentra
  return { bg: 'bg-gray-500/20', text: 'text-gray-400', border: 'border-gray-500/30' };
};

// Función para calcular clientes multi-producto
const calcularMultiProductoStats = (distribucionProducto, totalClientesUnicos) => {
  if (!distribucionProducto || distribucionProducto.length === 0 || !totalClientesUnicos) {
    return {
      total_clientes: 0,
      total_multi_producto: 0,
      porcentaje_multi_producto: 0
    };
  }

  // Sumar todos los clientes asignados a productos
  const totalAsignaciones = distribucionProducto.reduce((sum, producto) => {
    return sum + (producto.total_clientes || 0);
  }, 0);

  console.log('🧮 Calculando Multi-Producto:');
  console.log('  Total asignaciones por producto:', totalAsignaciones);
  console.log('  Total clientes únicos:', totalClientesUnicos);

  // Si hay más asignaciones que clientes únicos, hay overlap (multi-producto)
  const clientesMultiProducto = Math.max(0, totalAsignaciones - totalClientesUnicos);
  const porcentaje = totalClientesUnicos > 0 
    ? parseFloat(((clientesMultiProducto / totalClientesUnicos) * 100).toFixed(1))
    : 0;

  const resultado = {
    total_clientes: totalClientesUnicos,
    total_multi_producto: clientesMultiProducto,
    porcentaje_multi_producto: porcentaje
  };

  console.log('  Resultado:', resultado);

  return resultado;
};

export default function FinOpsGerenteDashboard() {
  const [clientes, setClientes] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('activo');
  const [sectorFilter, setSectorFilter] = useState('');
  const [csmFilter, setCsmFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [expandedRows, setExpandedRows] = useState({});
  const [expandedSapIds, setExpandedSapIds] = useState({});
  const [expandedOportunidades, setExpandedOportunidades] = useState({});
  const [clienteDetalles, setClienteDetalles] = useState({});
  const [oportunidadesDetalles, setOportunidadesDetalles] = useState({});
  const [serviciosDetalles, setServiciosDetalles] = useState({});
  
  // Estados para análisis de servicios y nubes
  const [serviciosPorNube, setServiciosPorNube] = useState([]);
  const [nubesLista, setNubesLista] = useState([]);
  const [selectedNube, setSelectedNube] = useState(null);
  const [multiNubeStats, setMultiNubeStats] = useState({});
  const [distribucionNube, setDistribucionNube] = useState([]);
  const [distribucionProducto, setDistribucionProducto] = useState([]);

  // Estado para multi-producto stats
  const [multiProductoStats, setMultiProductoStats] = useState({
    total_clientes: 0,
    total_multi_producto: 0,
    porcentaje_multi_producto: 0
  });

  const [filtrosGlobales, setFiltrosGlobales] = useState({
    nubes: [],
    productos: []
  });
  const [totalesNube, setTotalesNube] = useState({
    total_servicios: 0,
    oportunidades_unicas: 0,
    total_lineas: 0,
    clientes_unicos: 0
  });
  
  const [globalDateFilter, setGlobalDateFilter] = useState({
    type: 'relative',
    amount: 365,
    unit: 'days'
  });

  // Cargar datos
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        console.log('🔄 Cargando datos FINOPS consolidados...');
        const startTime = performance.now();
        
        const dateFilters = {
          fecha_inicio: globalDateFilter.startDate,
          fecha_fin: globalDateFilter.endDate,
          estado: statusFilter || undefined,
          nube_servicio: filtrosGlobales.nubes && filtrosGlobales.nubes.length > 0 
            ? filtrosGlobales.nubes[0] 
            : undefined,
          producto: filtrosGlobales.productos && filtrosGlobales.productos.length > 0 
            ? filtrosGlobales.productos[0] 
            : undefined
        };

        // LLAMADA CONSOLIDADA
        const dashboardData = await fetchFinopsDashboardData(dateFilters);
        
        // Actualizar estados con los datos consolidados
        setStats(dashboardData.kpis || {
          total_clientes: 0,
          total_servicios: 0,
          contratos_activos: 0,
          clientes_con_servicios: 0,
          total_oportunidades: 0
        });
        
        setDistribucionNube(dashboardData.distribucion_nube || []);
        setDistribucionProducto(dashboardData.distribucion_producto || []);

        // CALCULAR MULTI-PRODUCTO
        const multiProductoCalculado = calcularMultiProductoStats(
          dashboardData.distribucion_producto || [],
          dashboardData.kpis?.total_clientes || 0
        );
        setMultiProductoStats(multiProductoCalculado);

        setMultiNubeStats(dashboardData.multi_nube_stats || {
          total_clientes: 0,
          total_multi_nube: 0,
          porcentaje_multi_nube: 0
        });
        setNubesLista(dashboardData.nubes_lista || []);
        
        // Seleccionar primera nube automáticamente
        if (dashboardData.nubes_lista && dashboardData.nubes_lista.length > 0) {
          const primeraNube = dashboardData.nubes_lista[0].nube_servicio;
          setSelectedNube(primeraNube);
        }
        
        // Cargar clientes
        const clientesData = await fetchFinopsClientes({
          ...dateFilters,
          nube_servicio: filtrosGlobales.nubes && filtrosGlobales.nubes.length > 0 
            ? filtrosGlobales.nubes[0] 
            : undefined,
          producto: filtrosGlobales.productos && filtrosGlobales.productos.length > 0 
            ? filtrosGlobales.productos[0] 
            : undefined
        });
        setClientes(clientesData);
        
        const endTime = performance.now();
        const loadTime = ((endTime - startTime) / 1000).toFixed(2);
        
        console.log(`✅ Dashboard FINOPS cargado en ${loadTime} segundos`);
        console.log(`📊 Total clientes: ${dashboardData.kpis?.total_clientes || 0}`);
        console.log(`📊 Total nubes: ${dashboardData.distribucion_nube?.length || 0}`);
        console.log(`📊 Total productos: ${dashboardData.distribucion_producto?.length || 0}`);
        console.log(`📊 Multi-producto: ${multiProductoCalculado.total_multi_producto} (${multiProductoCalculado.porcentaje_multi_producto}%)`);
      } catch (error) {
        console.error('❌ Error loading FINOPS data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [globalDateFilter, statusFilter, filtrosGlobales]);

  // useEffect para refrescar servicios cuando cambia la nube seleccionada o los filtros
  useEffect(() => {
  const loadServiciosPorNube = async () => {
    if (!selectedNube) {
      setServiciosPorNube([]);
      setTotalesNube({
        total_servicios: 0,
        oportunidades_unicas: 0,
        total_lineas: 0,
        clientes_unicos: 0
      });
      return;
    }
    
    try {
      console.log('🔄 Refrescando servicios por nube...');
      console.log('   Nube:', selectedNube);
      console.log('   Producto:', filtrosGlobales.productos?.[0] || 'ninguno');
      
      const serviciosNubeData = await fetchServiciosPorNube(
        selectedNube,
        filtrosGlobales.productos && filtrosGlobales.productos.length > 0 
          ? filtrosGlobales.productos[0] 
          : undefined
      );
      
      setServiciosPorNube(serviciosNubeData.servicios || []);
      setTotalesNube(serviciosNubeData.totales || {
        total_servicios: 0,
        oportunidades_unicas: 0,
        total_lineas: 0,
        clientes_unicos: 0
      });
      
      console.log('✅ Servicios actualizados:', serviciosNubeData.servicios?.length || 0);
    } catch (error) {
      console.error('❌ Error al refrescar servicios:', error);
    }
  };
  
  loadServiciosPorNube();
}, [selectedNube, filtrosGlobales.productos]);

  // Control de header al hacer scroll
  useEffect(() => {
    const controlHeader = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsHeaderVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlHeader);
    return () => window.removeEventListener('scroll', controlHeader);
  }, [lastScrollY]);


  const handleManualRefresh = async () => {
    setRefreshing(true);
    try {
      console.log('🔄 Refrescando dashboard...');
      const startTime = performance.now();
      
      const dateFilters = {
        fecha_inicio: globalDateFilter.startDate,
        fecha_fin: globalDateFilter.endDate,
        estado: statusFilter || undefined,
        nube_servicio: filtrosGlobales.nubes && filtrosGlobales.nubes.length > 0 
          ? filtrosGlobales.nubes[0] 
          : undefined,
        producto: filtrosGlobales.productos && filtrosGlobales.productos.length > 0 
          ? filtrosGlobales.productos[0] 
          : undefined
      };

      const dashboardData = await fetchFinopsDashboardData(dateFilters);
      
      setStats(dashboardData.kpis || {
        total_clientes: 0,
        total_servicios: 0,
        contratos_activos: 0,
        clientes_con_servicios: 0,
        total_oportunidades: 0
      });
      
      setDistribucionNube(dashboardData.distribucion_nube || []);
      setDistribucionProducto(dashboardData.distribucion_producto || []);
      
      // 🔥 CALCULAR MULTI-PRODUCTO EN REFRESH
      const multiProductoCalculado = calcularMultiProductoStats(
        dashboardData.distribucion_producto || [],
        dashboardData.kpis?.total_clientes || 0
      );
      setMultiProductoStats(multiProductoCalculado);

      setMultiNubeStats(dashboardData.multi_nube_stats || {
        total_clientes: 0,
        total_multi_nube: 0,
        porcentaje_multi_nube: 0
      });
      setNubesLista(dashboardData.nubes_lista || []);
      
      if (dashboardData.nubes_lista && dashboardData.nubes_lista.length > 0) {
        const primeraNube = dashboardData.nubes_lista[0].nube_servicio;
        if (selectedNube !== primeraNube) {
          setSelectedNube(primeraNube);
        } else {
          const serviciosNubeData = await fetchServiciosPorNube(
            primeraNube,
            filtrosGlobales.productos && filtrosGlobales.productos.length > 0 
              ? filtrosGlobales.productos[0] 
              : undefined
          );
          setServiciosPorNube(serviciosNubeData.servicios || []);
          setTotalesNube(serviciosNubeData.totales || {
            total_servicios: 0,
            oportunidades_unicas: 0,
            total_lineas: 0,
            clientes_unicos: 0
          });
        }
      }
      
      const clientesData = await fetchFinopsClientes(dateFilters);
      setClientes(clientesData);
      
      const endTime = performance.now();
      const loadTime = ((endTime - startTime) / 1000).toFixed(2);
      console.log(`✅ Dashboard refrescado en ${loadTime} segundos`);
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setRefreshing(false);
    }
  };

  const handleDateFilterChange = (newDateFilter) => {
    setGlobalDateFilter(newDateFilter);
  };

  const handleNubeClick = (nube) => {
    setFiltrosGlobales(prev => {
      const nubesActuales = prev.nubes || [];
      
      if (nubesActuales.includes(nube)) {
        return {
          ...prev,
          nubes: nubesActuales.filter(n => n !== nube)
        };
      }
      
      return {
        ...prev,
        nubes: [...nubesActuales, nube]
      };
    });
  };

  const handleProductoClick = (producto) => {
    setFiltrosGlobales(prev => {
      const productosActuales = prev.productos || [];
      
      if (productosActuales.includes(producto)) {
        return {
          ...prev,
          productos: productosActuales.filter(p => p !== producto)
        };
      }
      
      return {
        ...prev,
        productos: [...productosActuales, producto]
      };
    });
  };

  const limpiarFiltrosGlobales = () => {
    setFiltrosGlobales({
      nubes: [],
      productos: []
    });
  };

  const tieneFiltrosActivos = () => {
    return (filtrosGlobales.nubes && filtrosGlobales.nubes.length > 0) ||
          (filtrosGlobales.productos && filtrosGlobales.productos.length > 0);
  };

  const toggleExpandRow = async (nombreComercial) => {
    if (expandedRows[nombreComercial]) {
      setExpandedRows(prev => ({ ...prev, [nombreComercial]: false }));
    } else {
      setExpandedRows(prev => ({ ...prev, [nombreComercial]: true }));
      
      const cacheKey = `${nombreComercial}_${statusFilter || 'all'}`;
      
      if (!clienteDetalles[cacheKey]) {
        try {
          const estado = statusFilter || null;
          const detalles = await fetchClienteDetalles(nombreComercial, estado);
          setClienteDetalles(prev => ({ ...prev, [cacheKey]: detalles }));
        } catch (error) {
          console.error(`Error loading details for ${nombreComercial}:`, error);
        }
      }
    }
  };

  const toggleExpandSapId = async (sapId) => {
    if (expandedSapIds[sapId]) {
      setExpandedSapIds(prev => ({ ...prev, [sapId]: false }));
    } else {
      setExpandedSapIds(prev => ({ ...prev, [sapId]: true }));
      
      if (!oportunidadesDetalles[sapId]) {
        try {
          const oportunidades = await fetchClienteOportunidades(sapId);
          setOportunidadesDetalles(prev => ({ ...prev, [sapId]: oportunidades }));
        } catch (error) {
          console.error(`Error loading oportunidades for ${sapId}:`, error);
        }
      }
    }
  };

  const toggleExpandOportunidad = async (sapId, oportunidadId) => {
    const key = `${sapId}_${oportunidadId}`;
    
    if (expandedOportunidades[key]) {
      setExpandedOportunidades(prev => ({ ...prev, [key]: false }));
    } else {
      setExpandedOportunidades(prev => ({ ...prev, [key]: true }));
      
      if (!serviciosDetalles[key]) {
        try {
          const servicios = await fetchOportunidadServicios(sapId, oportunidadId);
          setServiciosDetalles(prev => ({ ...prev, [key]: servicios }));
        } catch (error) {
          console.error(`Error loading servicios for oportunidad ${oportunidadId}:`, error);
        }
      }
    }
  };

  const handleNubeChange = async (nubeServicio) => {
    console.log('🔄 Cambiando nube a:', nubeServicio);
    setSelectedNube(nubeServicio);
  };

  // Clases de estilo
  const cardClasses = isDarkMode
    ? 'bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 shadow-lg'
    : 'bg-white border border-gray-200 rounded-xl p-6 shadow-lg';

  const textPrimary = isDarkMode ? 'text-white' : 'text-gray-900';
  const textSecondary = isDarkMode ? 'text-gray-300' : 'text-gray-600';

  // Obtener valores únicos para filtros
  const sectoresUnicos = [...new Set(clientes.flatMap(c => c.sectores?.split(', ') || []).filter(Boolean))].sort();
  const csmsUnicos = [...new Set(clientes.flatMap(c => c.csms?.split(', ') || []).filter(Boolean))].sort();

  // Filtrar clientes
  const filteredClientes = clientes.filter(cliente => {
    const matchesSearch = cliente.nombre_comercial?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = !statusFilter || cliente.estados?.toLowerCase().includes(statusFilter.toLowerCase());
    const matchesSector = !sectorFilter || cliente.sectores?.includes(sectorFilter);
    const matchesCSM = !csmFilter || cliente.csms?.includes(csmFilter);
    return matchesSearch && matchesStatus && matchesSector && matchesCSM;
  });

  // Paginación
  const totalPages = Math.ceil(filteredClientes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedClientes = filteredClientes.slice(startIndex, endIndex);

  // Reset página cuando cambian los filtros
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter, sectorFilter, csmFilter]);

  const themeClasses = isDarkMode 
    ? 'bg-gradient-to-br from-[#001a14] via-[#002820] to-[#001410] text-white'
    : 'bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-50 text-gray-900';

  if (loading) {
    return (
      <div className={`min-h-screen ${themeClasses} flex items-center justify-center`}>
        <div className="flex items-center space-x-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00ffb3]"></div>
          <span className="text-xl font-semibold bg-gradient-to-r from-[#00ffb3] to-[#04d9ff] bg-clip-text text-transparent">
            Cargando dashboard FINOPS...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen ${themeClasses} transition-all duration-300`}>
      {/* Header */}
      <div 
        className={`sticky top-0 z-30 ${cardClasses} backdrop-blur-md transition-transform duration-300 ${
          isHeaderVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
        onMouseEnter={() => setIsHeaderVisible(true)}
      >
        <div className="absolute -bottom-2 left-0 right-0 h-2 bg-transparent"></div>
        
        <div className="flex justify-between items-center px-6 py-4">
          <div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-[#00ffb3] to-[#04d9ff] bg-clip-text text-transparent">
              FINOPS Dashboard
            </h1>
            <p className="text-lg opacity-80 mt-1">Gestión Financiera de Servicios Cloud</p>
          </div>
          
          <div className="flex items-center space-x-4">
            <DateFilterComponent
              onDateFilterChange={handleDateFilterChange}
              isDarkMode={isDarkMode}
            />

            <button
              onClick={handleManualRefresh}
              disabled={refreshing}
              className={`p-2 rounded-lg transition-all ${
                isDarkMode
                  ? 'bg-white/10 hover:bg-white/20 text-white'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              } ${refreshing ? 'opacity-50 cursor-not-allowed' : ''}`}
              title="Actualizar datos"
            >
              <RefreshCw className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`} />
            </button>

            {tieneFiltrosActivos() && (
              <button
                onClick={limpiarFiltrosGlobales}
                className={`px-4 py-2 rounded-lg transition-all flex items-center gap-2 ${
                  isDarkMode
                    ? 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/50'
                    : 'bg-red-100 hover:bg-red-200 text-red-700 border border-red-300'
                }`}
                title="Limpiar todos los filtros"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span className="text-sm font-medium">Limpiar filtros</span>
              </button>
            )}

            <button
              onClick={() => setIsDarkMode(!isDarkMode)}
              className={`p-2 rounded-lg transition-all ${
                isDarkMode
                  ? 'bg-white/10 hover:bg-white/20 text-white'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }`}
              title={isDarkMode ? 'Modo claro' : 'Modo oscuro'}
            >
              {isDarkMode ? <Moon className="w-5 h-5" /> : <MoonStar className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="px-6 py-8">
        {/* Indicador de filtros activos */}
        {tieneFiltrosActivos() && (
          <div className={`mb-6 p-4 rounded-lg ${
            isDarkMode 
              ? 'bg-blue-500/10 border border-blue-500/30' 
              : 'bg-blue-50 border border-blue-200'
          }`}>
            <div className="flex items-center gap-3 flex-wrap">
              <span className={`text-sm font-medium ${
                isDarkMode ? 'text-blue-300' : 'text-blue-700'
              }`}>
                Filtros activos:
              </span>
              
              {filtrosGlobales.nubes && filtrosGlobales.nubes.length > 0 && (
                <div className="flex items-center gap-2 flex-wrap">
                  {filtrosGlobales.nubes.map(nube => (
                    <span 
                      key={nube}
                      className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2 ${
                        isDarkMode
                          ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30'
                          : 'bg-cyan-100 text-cyan-700 border border-cyan-300'
                      }`}
                    >
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
                      </svg>
                      {nube}
                    </span>
                  ))}
                </div>
              )}
              
              {filtrosGlobales.productos && filtrosGlobales.productos.length > 0 && (
                <div className="flex items-center gap-2 flex-wrap">
                  {filtrosGlobales.productos.map(producto => (
                    <span 
                      key={producto}
                      className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2 ${
                        isDarkMode
                          ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30'
                          : 'bg-purple-100 text-purple-700 border border-purple-300'
                      }`}
                    >
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
                      </svg>
                      {producto}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00ffb3]"></div>
          </div>
        ) : (
          <div className="space-y-8">
            {/* 🔥 KPI Cards ACTUALIZADOS */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Total Clientes */}
              <div className={cardClasses}>
                <div className="flex items-center justify-between">
                  <div>
                    <p className={`${textSecondary} text-sm`}>Total Clientes</p>
                    <p className={`${textPrimary} text-3xl font-bold mt-2`}>
                      {stats.total_clientes || 0}
                    </p>
                    <p className={`${textSecondary} text-xs mt-1`}>Activos (excl. internos)</p>
                  </div>
                  <div className="p-3 bg-gradient-to-br from-green-500 to-green-600 rounded-lg">
                    <Users className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>

              {/* Total Nubes */}
              <div className={cardClasses}>
                <div className="flex items-center justify-between">
                  <div>
                    <p className={`${textSecondary} text-sm`}>Total Nubes</p>
                    <p className={`${textPrimary} text-3xl font-bold mt-2`}>
                      {distribucionNube?.length || 0}
                    </p>
                    <p className={`${textSecondary} text-xs mt-1`}>Proveedores cloud activos</p>
                  </div>
                  <div className="p-3 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-lg">
                    <Cloud className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>

              {/* Total Productos */}
              <div className={cardClasses}>
                <div className="flex items-center justify-between">
                  <div>
                    <p className={`${textSecondary} text-sm`}>Total Productos</p>
                    <p className={`${textPrimary} text-3xl font-bold mt-2`}>
                      {distribucionProducto?.length || 0}
                    </p>
                    <p className={`${textSecondary} text-xs mt-1`}>Tipos de productos ofrecidos</p>
                  </div>
                  <div className="p-3 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg">
                    <Tag className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>
            </div>

            {/* Análisis de Servicios y Nubes */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Gráfica Pie por NUBE */}
              <MultiNubePieChart
                distribucionData={distribucionNube || []}
                multiNubeStats={multiNubeStats}
                isDarkMode={isDarkMode}
                onNubeClick={handleNubeClick}
              />

              {/* Gráfica Pie por PRODUCTO */}
              <ProductoPieChart
                distribucionData={distribucionProducto || []}
                multiProductoStats={multiProductoStats}
                isDarkMode={isDarkMode}
                onProductoClick={handleProductoClick}
              />
            </div>


            {/* Tabla de Clientes */}
            <div className={cardClasses}>
              <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className={`${textPrimary} text-xl font-bold`}>Clientes</h2>
                  
                  <div className={`${textSecondary} text-sm`}>
                    Mostrando {startIndex + 1}-{Math.min(endIndex, filteredClientes.length)} de {filteredClientes.length}
                  </div>
                </div>
                
                {/* Búsqueda y filtros */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="relative">
                    <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 ${textSecondary}`} />
                    <input
                      type="text"
                      placeholder="Buscar cliente..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className={`w-full pl-10 pr-4 py-2 rounded-lg border ${
                        isDarkMode
                          ? 'bg-white/5 border-white/10 text-white placeholder-gray-400'
                          : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                      } focus:outline-none focus:ring-2 focus:ring-[#00ffb3]`}
                    />
                  </div>

                  <select
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setExpandedRows({});
                    }}
                    className={`px-4 py-2 rounded-lg border ${
                      isDarkMode
                        ? 'bg-white/5 border-white/10 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                    } focus:outline-none focus:ring-2 focus:ring-[#00ffb3]`}
                  >
                    <option value="">Histórico (Todos)</option>
                    <option value="activo">Activo</option>
                    <option value="baja definitiva">Baja Definitiva</option>
                    <option value="suspendido temporal">Suspendido Temporal</option>
                  </select>

                  <select
                    value={sectorFilter}
                    onChange={(e) => setSectorFilter(e.target.value)}
                    className={`px-4 py-2 rounded-lg border ${
                      isDarkMode
                        ? 'bg-white/5 border-white/10 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                    } focus:outline-none focus:ring-2 focus:ring-[#00ffb3]`}
                  >
                    <option value="">Todos los sectores</option>
                    {sectoresUnicos.map(sector => (
                      <option key={sector} value={sector}>{sector}</option>
                    ))}
                  </select>

                  <select
                    value={csmFilter}
                    onChange={(e) => setCsmFilter(e.target.value)}
                    className={`px-4 py-2 rounded-lg border ${
                      isDarkMode
                        ? 'bg-white/5 border-white/10 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                    } focus:outline-none focus:ring-2 focus:ring-[#00ffb3]`}
                  >
                    <option value="">Todos los CSM</option>
                    {csmsUnicos.map(csm => (
                      <option key={csm} value={csm}>{csm}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Tabla de clientes */}
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className={`border-b ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm w-10`}></th>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm`}>Nombre Comercial</th>
                      <th className={`${textSecondary} text-center py-3 px-4 font-medium text-sm`}>IDs SAP</th>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm`}>Estados</th>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm`}>Fecha Alta</th>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm`}>Sectores</th>
                      <th className={`${textSecondary} text-left py-3 px-4 font-medium text-sm`}>CSMs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedClientes.map((cliente, index) => {
                      const cacheKey = `${cliente.nombre_comercial}_${statusFilter || 'all'}`;
                      
                      return (
                        <React.Fragment key={cliente.nombre_comercial || index}>
                          <tr
                            className={`border-b ${isDarkMode ? 'border-white/5 hover:bg-white/5' : 'border-gray-100 hover:bg-gray-50'} transition-colors cursor-pointer`}
                            onClick={() => toggleExpandRow(cliente.nombre_comercial)}
                          >
                            <td className={`${textPrimary} py-3 px-4`}>
                              {expandedRows[cliente.nombre_comercial] ? (
                                <ChevronDown className="w-4 h-4" />
                              ) : (
                                <ChevronRight className="w-4 h-4" />
                              )}
                            </td>
                            <td className={`${textPrimary} py-3 px-4 font-medium`}>{cliente.nombre_comercial || 'N/A'}</td>
                            <td className="py-3 px-4 text-center">
                              <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-500/20 text-blue-400">
                                {cliente.total_sap_ids || 0}
                              </span>
                            </td>
                            <td className="py-3 px-4">
                              <div className="flex flex-wrap gap-1">
                                {cliente.estados?.split(', ').map((estado, i) => (
                                  <span key={i} className={`px-2 py-1 rounded-full text-xs font-medium ${
                                    estado.toLowerCase() === 'activo'
                                      ? 'bg-green-500/20 text-green-400'
                                      : estado.toLowerCase() === 'inactivo'
                                      ? 'bg-gray-500/20 text-gray-400'
                                      : 'bg-yellow-500/20 text-yellow-400'
                                  }`}>
                                    {estado}
                                  </span>
                                ))}
                              </div>
                            </td>
                            <td className={`${textSecondary} py-3 px-4 text-sm`}>
                              {cliente.fecha_alta_reciente ? new Date(cliente.fecha_alta_reciente).toLocaleDateString() : 'N/A'}
                            </td>
                            <td className={`${textSecondary} py-3 px-4 text-sm`}>{cliente.sectores || 'N/A'}</td>
                            <td className={`${textSecondary} py-3 px-4 text-sm`}>{cliente.csms || 'N/A'}</td>
                          </tr>
                          
                          {expandedRows[cliente.nombre_comercial] && clienteDetalles[cacheKey] && (
                            <tr className={isDarkMode ? 'bg-white/5' : 'bg-gray-50'}>
                              <td colSpan="7" className="py-2 px-4">
                                <div className="ml-8 space-y-1">
                                  {clienteDetalles[cacheKey].map((detalle, i) => (
                                    <div key={i}>
                                      <div 
                                        onClick={() => toggleExpandSapId(detalle.id)}
                                        className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer transition-colors ${
                                          isDarkMode ? 'hover:bg-white/10 bg-white/5' : 'hover:bg-gray-100 bg-white'
                                        } border ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}
                                      >
                                        <div className="w-6 flex-shrink-0">
                                          {expandedSapIds[detalle.id] ? (
                                            <ChevronDown className="w-4 h-4 text-green-400" />
                                          ) : (
                                            <ChevronRight className="w-4 h-4 text-gray-400" />
                                          )}
                                        </div>
                                        <div className="grid grid-cols-6 gap-4 flex-1 text-sm">
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>ID SAP:</span>
                                            <p className={`${textPrimary} font-medium`}>{detalle.id}</p>
                                          </div>
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>Razón Social:</span>
                                            <p className={`${textPrimary}`}>{detalle.nombre}</p>
                                          </div>
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>Estado:</span>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                              detalle.estado?.toLowerCase() === 'activo'
                                                ? 'bg-green-500/20 text-green-400'
                                                : 'bg-gray-500/20 text-gray-400'
                                            }`}>
                                              {detalle.estado}
                                            </span>
                                          </div>
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>CSM:</span>
                                            <p className={`${textPrimary}`}>{detalle.csm || 'N/A'}</p>
                                          </div>
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>Sector:</span>
                                            <p className={`${textPrimary}`}>{detalle.sector || 'N/A'}</p>
                                          </div>
                                          <div>
                                            <span className={`${textSecondary} text-xs`}>Fecha Alta:</span>
                                            <p className={`${textPrimary}`}>
                                              {detalle.fecha_alta ? new Date(detalle.fecha_alta).toLocaleDateString() : 'N/A'}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      {expandedSapIds[detalle.id] && oportunidadesDetalles[detalle.id] && (
                                        <div className={`ml-12 mt-2 p-4 rounded-lg ${isDarkMode ? 'bg-white/10' : 'bg-gray-100'}`}>
                                          <h5 className={`${textPrimary} font-semibold mb-3 text-sm`}>
                                            Oportunidades ({oportunidadesDetalles[detalle.id].length}):
                                          </h5>
                                          {oportunidadesDetalles[detalle.id].length === 0 ? (
                                            <p className={`${textSecondary} text-sm italic p-3`}>Sin oportunidades activas</p>
                                          ) : (
                                            <div className="space-y-2">
                                              {oportunidadesDetalles[detalle.id].map((oportunidad, j) => {
                                                const opKey = `${detalle.id}_${oportunidad.oportunidad}`;
                                                return (
                                                  <div key={j}>
                                                    <div 
                                                      onClick={() => toggleExpandOportunidad(detalle.id, oportunidad.oportunidad)}
                                                      className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer transition-colors ${
                                                        isDarkMode ? 'hover:bg-white/10 bg-white/5' : 'hover:bg-gray-100 bg-white'
                                                      } border ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}
                                                    >
                                                      <div className="w-6 flex-shrink-0">
                                                        {expandedOportunidades[opKey] ? (
                                                          <ChevronDown className="w-4 h-4 text-cyan-400" />
                                                        ) : (
                                                          <ChevronRight className="w-4 h-4 text-gray-400" />
                                                        )}
                                                      </div>
                                                      <div className="grid grid-cols-5 gap-4 flex-1 text-sm">
                                                        {/* 1. Oportunidad */}
                                                        <div>
                                                          <span className={`${textSecondary} text-xs`}>Oportunidad:</span>
                                                          <p className={`${textPrimary} font-medium`}>{oportunidad.oportunidad}</p>
                                                        </div>
                                                        
                                                        {/* 2. Servicios */}
                                                        <div>
                                                          <span className={`${textSecondary} text-xs`}>Servicios:</span>
                                                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400">
                                                            {oportunidad.total_servicios} servicio{oportunidad.total_servicios !== 1 ? 's' : ''}
                                                          </span>
                                                        </div>
                                                        
                                                        {/* 3. Estado */}
                                                        <div>
                                                          <span className={`${textSecondary} text-xs`}>Estado:</span>
                                                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                            oportunidad.estado?.toLowerCase() === 'activo'
                                                              ? 'bg-green-500/20 text-green-400'
                                                              : oportunidad.estado?.toLowerCase() === 'baja definitiva'
                                                              ? 'bg-red-500/20 text-red-400'
                                                              : oportunidad.estado?.toLowerCase() === 'suspendido temporal'
                                                              ? 'bg-yellow-500/20 text-yellow-400'
                                                              : 'bg-gray-500/20 text-gray-400'
                                                          }`}>
                                                            {oportunidad.estado || 'N/A'}
                                                          </span>
                                                        </div>
                                                        
                                                        {/* 4. NUBE - CON COLORES */}
                                                        <div>
                                                          <span className={`${textSecondary} text-xs`}>Nube:</span>
                                                          <div className="flex flex-wrap gap-1">
                                                            {oportunidad.nubes ? (
                                                              oportunidad.nubes.split(', ').map((nube, idx) => {
                                                                const colores = getColorNube(nube);
                                                                return (
                                                                  <span 
                                                                    key={idx} 
                                                                    className={`px-2 py-1 rounded-full text-xs font-medium ${colores.bg} ${colores.text} border ${colores.border}`}
                                                                  >
                                                                    {nube}
                                                                  </span>
                                                                );
                                                              })
                                                            ) : (
                                                              <span className="text-xs italic text-gray-400">Sin nube</span>
                                                            )}
                                                          </div>
                                                        </div>
                                                        
                                                        {/* 5. Descripción */}
                                                        <div>
                                                          <span className={`${textSecondary} text-xs`}>Descripción:</span>
                                                          <p className={`${textPrimary} truncate`}>{oportunidad.nombre_oportunidad || 'N/A'}</p>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {expandedOportunidades[opKey] && serviciosDetalles[opKey] && (
                                                      <div className={`ml-12 mt-2 p-4 rounded-lg ${isDarkMode ? 'bg-white/10' : 'bg-gray-100'}`}>
                                                        <h5 className={`${textPrimary} font-semibold mb-3 text-sm`}>
                                                          Servicios ({serviciosDetalles[opKey].length}):
                                                        </h5>
                                                        {serviciosDetalles[opKey].length === 0 ? (
                                                          <p className={`${textSecondary} text-sm italic`}>No hay servicios</p>
                                                        ) : (
                                                          <div className="overflow-x-auto">
                                                            <table className="w-full text-sm">
                                                              <thead>
                                                                <tr className={`border-b ${isDarkMode ? 'border-white/20' : 'border-gray-300'}`}>
                                                                  <th className={`${textSecondary} text-left py-2 px-3 font-medium text-xs`}>Servicio</th>
                                                                  <th className={`${textSecondary} text-center py-2 px-3 font-medium text-xs`}>Cantidad</th>
                                                                  <th className={`${textSecondary} text-left py-2 px-3 font-medium text-xs`}>Fecha Inicio</th>
                                                                  <th className={`${textSecondary} text-left py-2 px-3 font-medium text-xs`}>Fecha Fin</th>
                                                                  <th className={`${textSecondary} text-left py-2 px-3 font-medium text-xs`}>Renovación</th>
                                                                  <th className={`${textSecondary} text-left py-2 px-3 font-medium text-xs`}>Nube</th>
                                                                  <th className={`${textSecondary} text-right py-2 px-3 font-medium text-xs`}>Costo OP</th>
                                                                  <th className={`${textSecondary} text-right py-2 px-3 font-medium text-xs`}>Ingreso OP</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {serviciosDetalles[opKey].map((servicio, k) => (
                                                                  <tr key={k} className={`border-b ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}>
                                                                    <td className={`${textPrimary} py-2 px-3 font-medium`}>{servicio.servicio || '-'}</td>
                                                                    <td className={`${textPrimary} py-2 px-3 text-center`}>{servicio.cantidad || '-'}</td>
                                                                    <td className={`${textSecondary} py-2 px-3`}>
                                                                      {servicio.fecha_inicio_contrato ? new Date(servicio.fecha_inicio_contrato).toLocaleDateString() : '-'}
                                                                    </td>
                                                                    <td className={`${textSecondary} py-2 px-3`}>
                                                                      {servicio.fecha_termino_contrato ? new Date(servicio.fecha_termino_contrato).toLocaleDateString() : '-'}
                                                                    </td>
                                                                    <td className={`${textSecondary} py-2 px-3`}>
                                                                      {servicio.fecha_renovacion_consola ? new Date(servicio.fecha_renovacion_consola).toLocaleDateString() : '-'}
                                                                    </td>
                                                                    <td className={`${textPrimary} py-2 px-3`}>{servicio.nube_servicio || '-'}</td>
                                                                    <td className={`${textPrimary} py-2 px-3 text-right`}>
                                                                      {servicio.costo_op ? `$${servicio.costo_op.toLocaleString()}` : '-'}
                                                                    </td>
                                                                    <td className={`${textPrimary} py-2 px-3 text-right font-medium`}>
                                                                      {servicio.ingreso_op ? `$${servicio.ingreso_op.toLocaleString()}` : '-'}
                                                                    </td>
                                                                  </tr>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Paginación */}
              {totalPages > 1 && (
                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className={`px-4 py-2 rounded-lg transition-all ${
                      currentPage === 1
                        ? 'opacity-50 cursor-not-allowed'
                        : isDarkMode
                        ? 'bg-white/10 hover:bg-white/20 text-white'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                    }`}
                  >
                    Anterior
                  </button>

                  <div className="flex items-center gap-2">
                    {[...Array(totalPages)].map((_, i) => {
                      const pageNum = i + 1;
                      if (
                        pageNum === 1 ||
                        pageNum === totalPages ||
                        (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            className={`px-3 py-1 rounded-lg transition-all ${
                              currentPage === pageNum
                                ? 'bg-gradient-to-r from-[#00ffb3] to-[#04d9ff] text-white font-bold'
                                : isDarkMode
                                ? 'bg-white/10 hover:bg-white/20 text-white'
                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                            }`}
                          >
                            {pageNum}
                          </button>
                        );
                      } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
                        return <span key={pageNum} className={textSecondary}>...</span>;
                      }
                      return null;
                    })}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className={`px-4 py-2 rounded-lg transition-all ${
                      currentPage === totalPages
                        ? 'opacity-50 cursor-not-allowed'
                        : isDarkMode
                        ? 'bg-white/10 hover:bg-white/20 text-white'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                    }`}
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </div>

            {/* Tabla de Servicios por Nube */}
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
              <ServiciosPorNubeTable
                servicios={serviciosPorNube}
                nubesLista={nubesLista}
                selectedNube={selectedNube}
                onNubeChange={handleNubeChange}
                totalesNube={totalesNube}
                isDarkMode={isDarkMode}
              />
            </div>

            {/* Última actualización */}
            {stats.ultima_actualizacion && (
              <div className={`${textSecondary} text-center text-sm`}>
                Última actualización: {new Date(stats.ultima_actualizacion).toLocaleString()}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}